const PENDING_REMOVE_KEY = 'favorites-pending-remove';

export function readPendingFavoriteRemoveIds(): number[] {
  if (typeof window === 'undefined') {
    return [];
  }

  try {
    const raw = sessionStorage.getItem(PENDING_REMOVE_KEY);
    if (!raw) {
      return [];
    }
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) {
      return [];
    }

    return parsed
      .map((id) => Number(id))
      .filter((id) => Number.isFinite(id));
  } catch {
    return [];
  }
}

export function addPendingFavoriteRemove(productId: number): void {
  if (typeof window === 'undefined') {
    return;
  }

  const next = new Set(readPendingFavoriteRemoveIds());
  next.add(productId);
  sessionStorage.setItem(PENDING_REMOVE_KEY, JSON.stringify([...next]));
}

export function removePendingFavoriteRemove(productId: number): void {
  if (typeof window === 'undefined') {
    return;
  }

  const next = readPendingFavoriteRemoveIds().filter((id) => id !== productId);
  if (next.length === 0) {
    sessionStorage.removeItem(PENDING_REMOVE_KEY);
  } else {
    sessionStorage.setItem(PENDING_REMOVE_KEY, JSON.stringify(next));
  }
}

export function clearPendingFavoriteRemovals(): void {
  if (typeof window === 'undefined') {
    return;
  }

  sessionStorage.removeItem(PENDING_REMOVE_KEY);
}

export function isFullPageReload(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  const nav = performance.getEntriesByType(
    'navigation',
  )[0] as PerformanceNavigationTiming | undefined;

  return nav?.type === 'reload';
}
